import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideCitadelSystemStyleDefaults } from '@citadel/controls';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

if (environment.production) {
  enableProdMode();
}

platformBrowser(providers).bootstrapModule(AppModule, { applicationProviders: [
  provideZoneChangeDetection(),
  // Required for CitadelCoreModule's HTTP_INTERCEPTORS to run at all — the auth-token
  // interceptor among them. The module registers them but does not itself enable DI
  // interceptors, so without this every API call goes out unauthenticated (401).
  provideHttpClient(withInterceptorsFromDi()),
  // Seeds the default page and control style from the active system's theme.
  provideCitadelSystemStyleDefaults(),
], })
  .catch(err => console.log(err));

//export { renderModule, renderModuleFactory } from '@angular/platform-server';
if (!window.crypto.randomUUID) {
  window.crypto.randomUUID = function (): `${string}-${string}-${string}-${string}-${string}` {
    return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (character: string) => {
      const value = Number(character);
      const randomValue = crypto.getRandomValues(new Uint8Array(1))[0];

      return (value ^ (randomValue & 15) >> value / 4).toString(16);
    }) as any;
  };
}

